<template>
  <div class="home">
    <SearchMaterialsWithSteps/>
  </div>
</template>

<script>
import SearchMaterialsWithSteps from '@/components/SearchMaterialsWithSteps.vue';

export default {
  name: 'Home',
  components: {
    SearchMaterialsWithSteps,
  },
  metaInfo() {
    return {
      title: `${this.$t('stepsView.meta.title')} - Nissens Support`,
      meta: [
        {
          name: 'description',
          content: this.$t('stepsView.meta.description'),
        },
      ],
    };
  },
};
</script>
